module.exports = __webpack_public_path__ + "media/images/bondform_bearhead2-973f1c2931151765bd326db93393313b.gif";